import { _ } from "../../vendor";
import InboomaBaseModel from "./InboomaBaseModel";

export default InboomaBaseModel.extend({
  urlRoot: "/appointments",

  _rbac: {
    // @todo
    admin: {
      read: true,
      write: true,
      edit: true,
      remove: true,
    },
    user: {
      read: false,
      write: false,
      edit: false,
      remove: false,
    },
    guide: {
      read: true,
      write: false,
      edit: false,
      remove: false,
    },
  },

  defaults: {
    id: "",
    client_id: "",
    begin: "",
    end: "",
    name: "",
    description: "",
    event_id: "",
    max_pers_count: "",
    current_available_pers_count: "",
    created: "",
    modified: "",
    deleted: null,
  },
});
